/** Silent autoplay loop that replaces a static visual; falls back to the poster until the render exists. */
export default function LoopVisual({ src, webm, poster, alt, testid, className = "" }) {
  return (
    <video
      className={`absolute inset-0 w-full h-full object-cover ${className}`}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-label={alt}
      data-testid={testid}
    >
      <source src={src} type="video/mp4" />
      {webm && <source src={webm} type="video/webm" />}
    </video>
  );
}
